export default "/images/vendor/quill/icons/indent.svg?b5fc7f81a004c4855833c500b0c538db";